<template>
  <div class="page-wrapper">
    <HeaderComponent />
    <div class="page-content">
      <AppBreadcrumb :items="[{ label: 'Jarimalar' }]" />


      <a-table
        :dataSource="fines"
        :pagination="false"
        rowKey="id"
        class="theme-aware-box"
      >
        <a-table-column title="№" key="id" data-index="id" />
        <a-table-column title="Jarima turi" key="title" data-index="title" />
        <a-table-column title="Miqdori" key="amount" data-index="amount" />
      </a-table>
    </div>
  </div>
</template>

<script>
import HeaderComponent from '../components/HeaderComponent.vue'
import AppBreadcrumb from '../components/AppBreadcrumb.vue'

export default {
  components: {
    HeaderComponent,
    AppBreadcrumb
  },
  computed: {
    fines() {
      return this.$store.getters.fines
    }
  }
}
</script>